import { RichTextField } from "@sitecore-jss/sitecore-jss-nextjs";
import { Box } from "@chakra-ui/react";
import SCRichText from "components/sc/SCRichText";

interface Fields {
    ContentText: RichTextField;
}

export type RichTextProps = {
    params: { [key: string]: string };
    fields: Fields;
};

export const RichText = (props: RichTextProps) => {
    return <SCRichText richTextField={props.fields?.ContentText} />;
};

export const RichTextBoxed = (props: RichTextProps) => {
    return (
        <Box
            backgroundColor={"brand.lighterGray"}
            p={{ base: "sp16", lg: "sp32" }}
            borderRadius={"base"}
        >
            <SCRichText richTextField={props.fields?.ContentText} />
        </Box>
    );
};
